import { graphql } from '~/lib/graphql'

export const PlanInventoryCalendar = graphql(/* GraphQL */ `
  query PlanInventoryCalendar(
    $restaurantId: RestaurantId!
    $planId: PlanId!
    $to: Date!
    $visitorsCount: Int!
    $input: PlanInventoryCalendarInput!
  ) {
    restaurant(restaurantId: $restaurantId) {
      plan(planId: $planId) {
        inventoryCalendar(to: $to, visitorsCount: $visitorsCount, input: $input) {
          ...InventoryCalendarItem
        }
      }
    }
  }
`)

export const InventoryCalendarItem = graphql(/* GraphQL */ `
  fragment InventoryCalendarItem on PlanInventoryCalendar {
    date {
      date
      holiday
      dayOfWeek
    }
    inventory {
      visitTime
      price
      seats {
        seatId
      }
      discountRatePercent
    }
  }
`)

export const PlanReservableVisitorsCounts = graphql(/* GraphQL */ `
  query PlanReservableVisitorsCounts($restaurantId: RestaurantId!, $planId: PlanId!) {
    restaurant(restaurantId: $restaurantId) {
      reservableVisitorsCounts(input: { planIds: [$planId] })
      plan(planId: $planId) {
        additionalContents
        restrictions
        mealPeriod
        isSeatOnly
        course {
          name
        }
        capacityRange {
          lower
          upper
        }
      }
    }
  }
`)
